
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import logoImg from "../../assets/logo-Innovia.png";
import { updateData } from "../../hooks/update";

const LoginPage = () => {
  const navigate = useNavigate();
  const email = useRef("");
  const password = useRef("");

  const handleLogin = (e) => {
    e.preventDefault();
    sessionStorage.clear();
    const data = {
      email: email.current.value,
      password: password.current.value,
    };
    updateData("user/login", data, null, true, true, navigate, null);

  };

  return (
    <div
      style={{
        backgroundImage: `url(
          "https://images.pexels.com/photos/3158651/pexels-photo-3158651.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
        )`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      className="h-[100vh] flex items-center justify-center"
    >
      <div className="bg-white/40 backdrop-blur-[10px] shadow-neumorph border-[#222] rounded-lg min-w-[300px] md:min-w-[450px] flex flex-col px-8 py-10 gap-12">
        <img src={logoImg} alt="logo" className="w-44 mx-auto" />
        <form onSubmit={handleLogin} className="px-4">
          <div className="mb-4">
            <label
              className="block text-black text-base font-medium mb-2 tracking-wide"
              htmlFor="username"
            >
              Username/email
            </label>
            <input
              ref={email}
              className="shadow appearance-none bg-[#ddd]/60 border-none rounded w-full py-4 px-4 text-gray-900 placeholder:text-[#DB0029] leading-tight focus:outline-none focus:shadow-outline"
              id="username"
              type="text"
              placeholder="Username or Email"
              required
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-black text-base font-medium mb-2 tracking-wide"
              htmlFor="password"
            >
              Password
            </label>
            <input
              ref={password}
              className="shadow appearance-none bg-[#ddd]/60 border-none rounded w-full py-4 px-4 text-gray-900 placeholder:text-[#DB0029] leading-tight focus:outline-none focus:shadow-outline"
              id="password"
              type="password"
              autoComplete="off"
              placeholder="Password"
              required
            />
          </div>
          <button className="mt-8 w-full py-3 bg-white/10 text-[#DB0029] hover:bg-[#DB0029] border border-[#DB0029] hover:text-white hover:border-transparent text-lg font-semibold transition-all duration-300 tracking-wide rounded-md">
            Log In
          </button>
        </form>
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default LoginPage;